import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useMediumAndLongPress from 'hooks/useMediumAndLongPress';
const ProductListingLoadMoreButton = t0 => {
  const $ = _c(24);
  const {
    clickCount,
    isLoading,
    onClick,
    onLongPress
  } = t0;
  let t1;
  if ($[0] !== onClick || $[1] !== onLongPress) {
    t1 = {
      onClick,
      onLongPress
    };
    $[0] = onClick;
    $[1] = onLongPress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchStart,
    hasMediumPressed
  } = useMediumAndLongPress(t1);
  const detectLongPresses = !!onLongPress;
  let t2;
  if ($[3] !== detectLongPresses || $[4] !== onMouseDown || $[5] !== onMouseLeave || $[6] !== onMouseUp || $[7] !== onTouchEnd || $[8] !== onTouchStart) {
    t2 = detectLongPresses ? {
      onMouseDown,
      onMouseLeave,
      onMouseUp,
      onTouchEnd,
      onTouchStart
    } : {};
    $[3] = detectLongPresses;
    $[4] = onMouseDown;
    $[5] = onMouseLeave;
    $[6] = onMouseUp;
    $[7] = onTouchEnd;
    $[8] = onTouchStart;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const longPressEventHandlers = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames("flex p-2 relative");
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = !detectLongPresses ? onClick : _temp;
  let t5;
  if ($[11] !== clickCount || $[12] !== isLoading || $[13] !== longPressEventHandlers || $[14] !== t4) {
    t5 = <span className="z-20 bg-white p-[5px] rounded-md"><CtaButton data-click-count={clickCount} onClick={t4} isLoading={isLoading} styling="outline-button" {...longPressEventHandlers}>Load More</CtaButton></span>;
    $[11] = clickCount;
    $[12] = isLoading;
    $[13] = longPressEventHandlers;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = !hasMediumPressed;
  const t7 = onLongPress && hasMediumPressed;
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = classNames("absolute inset-[5px] p-[5px] pointer-events-none z-10 rounded-lg", "[mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]", "before:block before:top-1/2 before:left-1/2 before:content-[''] before:absolute  before:w-[calc(100%_*_1.41421356237)] before:pb-[calc(100%_*_1.41421356237)] before:-translate-x-1/2 before:-translate-y-1/2 before:bg-conic-rainbow before:animate-border-spin", {
      "opacity-0": t6,
      "animate-fade-in": t7
    });
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <span className={t8} />;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t5 || $[22] !== t9) {
    t10 = <div className={t3}>{t5}{t9}</div>;
    $[21] = t5;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
ProductListingLoadMoreButton.propTypes = {
  clickCount: PropTypes.number,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  onLongPress: PropTypes.func
};
export default ProductListingLoadMoreButton;
function _temp() {}